import { Suspense, lazy, type ComponentProps } from 'react';
import type { RichText as RichTextView, RichTextEditor as Editor } from './RichTextEditor';

/**
 * The editor (TipTap and ProseMirror) is about a third of the app's code, and
 * only a contract's pages use it. Loaded on demand, the rest of Finance stays
 * as light as it was; the first contract page fetches it once.
 */
const EditorChunk = lazy(() => import('./RichTextEditor').then((m) => ({ default: m.RichTextEditor })));
const ViewChunk = lazy(() => import('./RichTextEditor').then((m) => ({ default: m.RichText })));

export function RichTextEditor(props: ComponentProps<typeof Editor>) {
  // As tall as the editor it stands in for: its toolbar and its empty text.
  const height = props.compact ? 'h-[156px]' : 'h-[226px]';
  return (
    <Suspense fallback={<div className={`${height} rounded-md border hairline bg-[var(--surface-raised)]`} aria-busy />}>
      <EditorChunk {...props} />
    </Suspense>
  );
}

export function RichText(props: ComponentProps<typeof RichTextView>) {
  return (
    <Suspense fallback={<div className="h-6" aria-busy />}>
      <ViewChunk {...props} />
    </Suspense>
  );
}
